import {fetchBody} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";
import { URL_ADDR_GET_CITY_LIST, URL_ADDR_GET_DIST_LIST } from "../config";

export function api_getAddrCityList ({success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({token}), 
      url: URL_ADDR_GET_CITY_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
export function api_getAddrDistList ({AddrCityID, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body:{AddrCityID}, token}), 
      url: URL_ADDR_GET_DIST_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}